/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S5_Li3Inputs */

const tr_servis_s5_li3 = /** @type {(inputs: Servis_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım Koşulları veya Servis Sözleşmesi'nin esaslı ihlali`)
};

const en_servis_s5_li3 = /** @type {(inputs: Servis_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material breach of the Terms of Use or of the Service Agreement`)
};

const de_servis_s5_li3 = /** @type {(inputs: Servis_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wesentlicher Verstoß gegen die Nutzungsbedingungen oder den Servicevertrag`)
};

const ru_servis_s5_li3 = /** @type {(inputs: Servis_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Существенное нарушение Условий использования или Сервисного договора`)
};

/**
* | output |
* | --- |
* | "Material breach of the Terms of Use or of the Service Agreement" |
*
* @param {Servis_S5_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s5_li3 = /** @type {((inputs?: Servis_S5_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S5_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s5_li3(inputs)
	if (locale === "de") return de_servis_s5_li3(inputs)
	if (locale === "ru") return ru_servis_s5_li3(inputs)
	return tr_servis_s5_li3(inputs)
});